import { useUiConfig } from "../useUiConfig.js";
export function useAuthConfig(selector) {
    const state = useUiConfig((state) => {
        if (!state.auth) {
            throw new Error("Auth config expected to be present in UiConfigStore");
        }
        return selector ? selector(state.auth) : state.auth;
    });
    return state;
}
//# sourceMappingURL=useAuthConfig.js.map